/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-unused-vars
import {
  ComboBox,
  Button,
  FormLabel,
  DropdownSkeleton,
  Loading,
  TextArea,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from 'carbon-components-react';
import React from 'react';
import { Offline, Online } from '../common/OnLineOffLine';

export const ChangeCompilerModal = (props) => {
  const isConfirmButtonDisabled = () => props.approver == null || props.approvalNotes == '' || props.approvalNotes == null;

  return (
    <ComposedModal
      className="light-modal box-medium-modal"
      open={props.show}
      danger="false"
      onClose={() => false}
    >
      <ModalHeader
        className="margin-modal"
        title={props.title}
        iconDescription="Close"
        buttonOnClick={props.onCancel}
      />

      <ModalBody className="margin-modal modal-nooverflow confirm-modal">
        <div>
          {props.isLoadingOptions ? (
            <DropdownSkeleton />
          ) : (
            <div>
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup>
                    <FormLabel className="some-class">Administrator*</FormLabel>
                    <ComboBox
                      id="combo-approval"
                      className="selection-items-list-costum"
                      //placeholder="Select a Administrator"
                      items={props.approverOptions}
                      itemToString={(item) =>
                        item ? `${item.name} ${item.surname} (${item.email})` : ''
                      }
                      itemToElement={(item) =>
                        item ? `${`${item.name} ${item.surname} (${item.email})`} ` : ''
                      }
                      onChange={({ selectedItem }) => props.onApproverSelect(selectedItem)}
                    />
                  </FormGroup>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup>
                    <FormLabel className="some-class">Reasons for change*</FormLabel>
                    <TextArea
                      maxLength={5000}
                      id="approvalNotes"
                      //placeholder="Reasons for change"
                      //value={props.approvalNotes}
                      onChange={props.onApprovalNotesChange}
                      hideLabel
                      labelText=""
                      light
                      rows={4}
                      cols={100}
                    />
                  </FormGroup>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="bx--row validation-row">
          <div className="bx--col">
            <ul>
              {props.validationMessages.map((e) => (
                <li className="srv-validation-message" key={e}>
                  {e}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="button--max-width" kind="secondary" onClick={props.onCancel}>
          Cancel
        </Button>
        <Online>
          <Button
            className="button--max-width"
            kind="primary"
            onClick={props.onConfirm}
            disabled={isConfirmButtonDisabled()}
          >
            Confirm
          </Button>
        </Online>
        <Offline>
          <Button className="button--max-width" kind="primary" onClick={props.onConfirm} disabled>
            Confirm
          </Button>
        </Offline>
      </ModalFooter>
      {!props.isLoadingOperation ? null : <Loading />}
    </ComposedModal>
  );
};
